import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleSwitchComponent } from '../components/toggle-switch/toggle-switch.component';
import { SimpleToggleComponent } from '../components/simple-toggle/simple-toggle.component';
import { TextBoxEntryComponent } from '../components/text-box-entry/text-box-entry.component';
import { NumberBoxEntryComponent } from '../components/number-box-entry/number-box-entry.component';
import { DropdownEntryComponent } from '../components/dropdown-entry/dropdown-entry.component';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/root-module/app-routing.module';
import { ProgressBarComponent } from '../components/progress-bar/progress-bar.component';
import { DatePickerModule } from 'primeng/datepicker';
import { HelpTextLinksComponent } from '../components/help-text-links/help-text-links.component';
import { CustomerTermPipe, CustomerTextPipe } from '../pipes/customer-term.pipe';



@NgModule({
  declarations: [
    ToggleSwitchComponent,
    SimpleToggleComponent,
    TextBoxEntryComponent,
    NumberBoxEntryComponent,
    DropdownEntryComponent,
    ProgressBarComponent,
    HelpTextLinksComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    DatePickerModule,
    CustomerTermPipe,
    CustomerTextPipe
  ],
  exports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    DatePickerModule,
    ToggleSwitchComponent,
    SimpleToggleComponent,
    TextBoxEntryComponent,
    NumberBoxEntryComponent,
    DropdownEntryComponent,
    ProgressBarComponent,
    HelpTextLinksComponent,
    CustomerTermPipe,
    CustomerTextPipe

  ]

})
export class SharedComponentsModule {



}
